import { render } from "./UpdatePasswordPage.vue?vue&type=template&id=2e4b87d6&ts=true"
import script from "./UpdatePasswordPage.vue?vue&type=script&lang=ts&setup=true"
export * from "./UpdatePasswordPage.vue?vue&type=script&lang=ts&setup=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/pages/authentication/UpdatePasswordPage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2e4b87d6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2e4b87d6', __exports__)) {
    api.reload('2e4b87d6', __exports__)
  }
  
  module.hot.accept("./UpdatePasswordPage.vue?vue&type=template&id=2e4b87d6&ts=true", () => {
    api.rerender('2e4b87d6', render)
  })

}


export default __exports__